import React, { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase";
import { useNavigate } from "react-router-dom";

// Import icons
import { FiMail, FiLock, FiEye, FiEyeOff } from "react-icons/fi";
import { FcGoogle } from "react-icons/fc";
import { BsMicrosoft, BsApple } from "react-icons/bs";
import { MdOutlineReceiptLong, MdInsights, MdSecurity } from "react-icons/md";

// Import images
import logo from "../assets/Logo_Icon.png"; 

import "../styles/Login.css";

function Login({ setIsLoggedIn }) {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const login = async (event) => {
    event?.preventDefault();
    if (isSubmitting) return;

    setIsSubmitting(true);
    try {
      await signInWithEmailAndPassword(auth, email, password);
      localStorage.setItem("isLoggedIn", "true");
      setIsLoggedIn(true);
      navigate("/");
    } catch (error) {
      alert(error.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="login-page">
      
      {/* LEFT PANEL - Promotional Info */}
      <div className="login-left">
        <div className="brand-header">
          <img src={logo} alt="logo" className="brand-logo" />
          <span className="brand-name">MyOwnBill</span>
        </div>

        <h1 className="hero-title">Smart Billing.<br/>Better Business.</h1>
        <p className="hero-subtitle">
          Manage invoices, inventory, customers and more – all in one place.
        </p>

        <div className="feature-list">
          <div className="feature-item">
            <div className="feature-icon blue-bg"><MdOutlineReceiptLong /></div>
            <div>
              <h3>Create & Manage Invoices</h3>
              <p>Fast and professional billing</p>
            </div>
          </div>
          <div className="feature-item">
            <div className="feature-icon green-bg"><MdInsights /></div>
            <div>
              <h3>Track Business Performance</h3>
              <p>Real-time insights & reports</p>
            </div>
          </div>
          <div className="feature-item">
            <div className="feature-icon purple-bg"><MdSecurity /></div>
            <div>
              <h3>Secure & Reliable</h3>
              <p>Your data is always protected</p>
            </div>
          </div>
        </div>

        {/* LAPTOP IMAGE IS NOW PLACED CORRECTLY HERE */}
        
        
        <div className="trust-badge">
          <MdSecurity className="shield-icon" /> Trusted by thousands of businesses
        </div>
      </div>

      {/* RIGHT PANEL - Login Form */}
      <div className="login-right">
        <div className="login-card">
          <h2>Welcome Back!</h2>
          <p className="login-subtitle">Sign in to continue to your account</p>

          <form onSubmit={login}>
            <div className="input-container">
              <label>Email Address</label>
              <div className="input-wrapper">
                <FiMail className="input-icon" />
                <input
                  type="email"
                  placeholder="Enter your email"
                  value={email}
                  autoComplete="username"
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
            </div>

            <div className="input-container">
              <label>Password</label>
              <div className="input-wrapper">
                <FiLock className="input-icon" />
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter your password"
                  value={password}
                  autoComplete="current-password"
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <button 
                  type="button" 
                  className="password-toggle"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <FiEyeOff /> : <FiEye />}
                </button>
              </div>
            </div>

            <div className="form-actions">
              <label className="checkbox-container">
                <input type="checkbox" /> Remember me
              </label>
              <a href="#" className="forgot-password">Forgot Password?</a>
            </div>

            <button type="submit" className="primary-btn" disabled={isSubmitting}>
              {isSubmitting ? "Signing in..." : "Sign In"}
            </button>
          </form>

          <div className="divider">
            <span>or continue with</span>
          </div>

          <div className="social-login">
            <button className="social-btn"><FcGoogle /> Continue with Google</button>
            <button className="social-btn"><BsMicrosoft color="#00a4ef" /> Continue with Microsoft</button>
            <button className="social-btn"><BsApple /> Continue with Apple</button>
          </div>

          <p className="signup-prompt">
            Don't have an account? <a href="#">Sign up</a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Login;